/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} External_Apis_Space_Access_EveryoneInputs */



/**
* | output |
* | --- |
* | "Everyone in the organization" |
*
* @param {External_Apis_Space_Access_EveryoneInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const external_apis_space_access_everyone = /** @type {((inputs?: External_Apis_Space_Access_EveryoneInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<External_Apis_Space_Access_EveryoneInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Alle in der Organisation")
	return /** @type {LocalizedString} */ ("Everyone in the organization")
});